import React, { useState, useEffect } from 'react';

import {
  Add
} from "@mui/icons-material";
import { Tooltip, Fab } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  Spell, 
  AbilityEffect,
} from "@dndModels";

// import API from "../../utilities/system_api";
// import DataUtilities from "../../utilities/common_utilities";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import AbilityEffectInput from "@dndComponents/feature/AbilityEffectInput";

interface Props {
  spell: Spell;
  disabled: boolean;
  onChange: () => void;
}

// const api = API.getInstance();
// const common_util = DataUtilities.getInstance();

export default function SpellEffects({
  spell,
  disabled,
  onChange
}: Props) {
  const [show_effect, setShowEffect] = useState("");
  const [reloading, setReloading] = useState(false);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <span className="header">
          Effects
        </span>
        { !disabled &&
          <Tooltip title={`Add Effect`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                const new_spell = spell;
                const effect = new AbilityEffect();
                if (spell.level === 0) {
                  effect.potence_type = "Character";
                } else {
                  effect.potence_type = "Slot";
                }
                new_spell.effects.push(effect);
                setShowEffect(effect.true_id);
                setReloading(true);
              }}>
              <Add/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      { !reloading && spell.effects.map((effect, key) => {
        let name = effect.type === "Damage" ? effect.damage_types.join(", ") : effect.type;
        if (!["None","Self Condition"].includes(effect.type) && effect.attack_type !== "None") {
          name += ` ${effect.attack_type}`
        }

        return (
          <Grid
            key={key}
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              size={{
                xs: 12
              }}>
              <ToggleButtonBox
                name={ name }
                // disabled={disabled}
                value={ show_effect === effect.true_id }
                onToggle={ () => { 
                  setShowEffect(show_effect === effect.true_id ? "" : effect.true_id);
                }}
              />
            </Grid>
            { show_effect === effect.true_id && 
              <Grid
                size={{
                  xs: 12
                }}>
                <AbilityEffectInput 
                  obj={effect}
                  disabled={disabled}
                  slot_level={spell.level}
                  onChange={onChange}
                  for_obj={spell}
                  onDelete={() => {
                    const new_spell = spell;
                    new_spell.effects = new_spell.effects.filter(o => o.true_id !== effect.true_id);
                    onChange();
                    setReloading(true);
                  }}
                />
              </Grid>        
            }
          </Grid>
        );
      })}
    </Grid>
  );
}